export const WORKFLOW_ACTIONS = {
  'UPDATE_BAR': 'WF_UPDATE_BAR',
  'INIT_BAR': 'WF_INIT_BAR',
};
